import { render, staticRenderFns } from "./NameModifyDialog.vue?vue&type=template&id=32685ecf"
import script from "./NameModifyDialog.vue?vue&type=script&lang=js"
export * from "./NameModifyDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports